import * as types from "../types";

const initialState = {
  contractors: []
};

export function contractorsReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CONTRACTORS:
      return {
        ...state,
        contractors: action.payload
      };
    default:
      return state;
  }
}
